export const GET_ALL_ORDER_REQUEST = "ORDER.GET_ALL_ORDER_REQUEST";
export const GET_ALL_ORDER_SUCCESS = "ORDER.GET_ALL_ORDER_SUCCESS";
export const GET_ALL_ORDER_FAILURE = "ORDER.GET_ALL_ORDER_FAILURE";

export const GET_MY_ORDER_REQUEST = "ORDER.GET_MY_ORDER_REQUEST";
export const GET_MY_ORDER_SUCCESS = "ORDER.GET_MY_ORDER_SUCCESS";
export const GET_MY_ORDER_FAILURE = "ORDER.GET_MY_ORDER_FAILURE";

export const CLEAR_SEARCHTERM = "ORDER.CLEAR_SEARCHTERM";

export const GET_SINGLE_ORDER_REQUEST = "ORDER.GET_SINGLE_ORDER_REQUEST";
export const GET_SINGLE_ORDER_SUCCESS = "ORDER.GET_SINGLE_ORDER_SUCCESS";
export const GET_SINGLE_ORDER_FAILURE = "ORDER.GET_SINGLE_ORDER_FAILURE";

export const ORDER_CREATE_REQUEST = "ORDER.ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER.ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAILURE = "ORDER.ORDER_CREATE_FAILURE";

export const PAY_ORDER_REQUEST = "ORDER.PAY_ORDER_REQUEST";
export const PAY_ORDER_SUCCESS = "ORDER.PAY_ORDER_SUCCESS";
export const PAY_ORDER_FAILURE = "ORDER.PAY_ORDER_FAILURE";

export const UPDATE_ORDER_REQUEST = "ORDER.UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "ORDER.UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAILURE = "ORDER.UPDATE_ORDER_FAILURE";

export const ORDER_DELETE_REQUEST = "ORDER.ORDER_DELETE_REQUEST";
export const ORDER_DELETE_SUCCESS = "ORDER.ORDER_DELETE_SUCCESS";
export const ORDER_DELETE_FAILURE = "ORDER.ORDER_DELETE_FAILURE";

export const ORDER_RESET = "ORDER_RESET";
